<template>
  <div class="error-page cell small-12 medium-10 large-8">
    <div class="error-card">
      <div class="error-header">
        <span class="badge-404">404</span>
        <h1>Page Not Found</h1>
      </div>

      <p class="description">
        We couldn't find the page you were looking for. It might have been moved, deleted, or perhaps the URL was mistyped.
      </p>

      <div class="actions">
        <router-link to="/" class="btn-primary">
          <font-awesome-icon :icon="['fas', 'house']" />
          <span>Return to Dashboard</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundPage'
};
</script>

<style lang="scss" scoped>
.error-page {
  margin: 3rem auto;
  display: flex;
  justify-content: center;
}

.error-card {
  /* Matches your dashboard widget card styling */
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 3.5rem 2.5rem;
  text-align: center;
  max-width: 580px;
  width: 100%;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.6);

  .error-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 1.25rem;

    .badge-404 {
      background: #fff3ec;
      color: #d35400; // Matches your local info orange
      font-size: 2.25rem;
      font-weight: 800;
      padding: 0.25rem 1.25rem;
      border-radius: 50px;
      letter-spacing: 1px;
    }

    h1 {
      font-size: 1.85rem;
      font-weight: 700;
      color: #2c3e50;
      margin: 0;
    }
  }

  .description {
    color: #64748b;
    font-size: 1rem;
    line-height: 1.6;
    margin-bottom: 2rem;
  }

  .actions {
    display: flex;
    justify-content: center;

    .btn-primary {
      display: inline-flex;
      align-items: center;
      gap: 0.6rem;
      background-color: #154c8c; // Matches your brand blue
      color: #ffffff;
      padding: 0.75rem 1.5rem;
      border-radius: 8px;
      font-weight: 600;
      font-size: 0.95rem;
      text-decoration: none;
      transition: background-color 0.2s ease, transform 0.15s ease;

      &:hover {
        background-color: #0f396b;
        transform: translateY(-1px);
      }
    }
  }
}
</style>